import React from 'react';
import { HOCs } from '@pearsontechnology/aero-components';

import AddProjectContentButton from './AddProjectContentButton';
import AddProjectContentMenu from './AddProjectContentMenu';

const { enhanceWithPopper } = HOCs;
const ButtonWithPopper = enhanceWithPopper(AddProjectContentButton);

const AddProjectContent = (props) => (
  <ButtonWithPopper placement="bottom-end" hidepopperonclick>
    <AddProjectContentMenu {...props} />
  </ButtonWithPopper>
);

export default AddProjectContent;
